function MaterialIssueIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0L5.33333 2.66667H6.66667V5.33333H9.33333V2.66667H10.6667M0.666666 1.33333V2.66667H2L4.4 7.73333L3.46667 9.33333C3.4 9.53333 3.33333 9.73333 3.33333 10C3.33333 10.7333 3.93333 11.3333 4.66667 11.3333H12.6667V10H4.93333C4.86667 10 4.8 9.93333 4.8 9.86667V9.8L5.4 8.66667H10.3333C10.8 8.66667 11.2667 8.4 11.4667 8L14.0667 3.33333L12.9333 2.66667L10.3333 7.33333H5.66667L2.86667 1.33333M4.66667 12C3.93333 12 3.33333 12.6 3.33333 13.3333C3.33333 14.0667 3.93333 14.6667 4.66667 14.6667C5.4 14.6667 6 14.0667 6 13.3333C6 12.6 5.4 12 4.66667 12ZM11.3333 12C10.6 12 10 12.6 10 13.3333C10 14.0667 10.6 14.6667 11.3333 14.6667C12.0667 14.6667 12.6667 14.0667 12.6667 13.3333C12.6667 12.6 12.0667 12 11.3333 12Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default MaterialIssueIcon
